module.exports = __webpack_public_path__ + "img/drivehorizon.8def18ed.jpg";